/**
 * „Nach Updates suchen“ – ein Baustein fuer Verwaltung, Cloud und Lead
 * Sheets. Zeigt den Stand dieses Geraets und den des Servers. Ein Tipp
 * genuegt: Ist der Server neuer, wird sofort aktualisiert. „Frisch laden“
 * holt alles neu vom Server, auch wenn beide gleich aussehen.
 */
import { h } from '../ui/dom.ts';
import { applyUpdate, buildDate, checkForUpdate } from './update-check.ts';

export function updateControl(opts: { onState?: (state: 'current' | 'outdated' | 'unknown') => void } = {}): HTMLElement {
  const lamp = h('span', { class: 'admin__lamp admin__lamp--busy' });
  const title = h('span', { class: 'admin__lamp-text', text: 'Prüfe …' });
  const sub = h('span', { class: 'admin__lamp-sub', text: `Dieses Gerät: ${buildDate(__BUILD_ID__)}` });
  const check = h('button', { class: 'btn btn--primary btn--small', text: 'Nach Updates suchen', attrs: { type: 'button' } });
  const fresh = h('button', { class: 'btn btn--small', text: 'Frisch laden', attrs: { type: 'button', title: 'Alles neu vom Server holen – Daten bleiben erhalten' } });

  async function run(apply: boolean): Promise<void> {
    lamp.className = 'admin__lamp admin__lamp--busy';
    title.textContent = 'Prüfe …';
    check.disabled = true;
    const s = await checkForUpdate();
    check.disabled = false;
    if (s.state === 'outdated') {
      lamp.className = 'admin__lamp admin__lamp--update';
      title.textContent = `Neuer Stand auf dem Server: ${buildDate(s.remote)}`;
      sub.textContent = `Dieses Gerät: ${buildDate(s.local)}`;
      opts.onState?.('outdated');
      if (apply) {
        title.textContent = 'Aktualisiere …';
        await applyUpdate();
      }
    } else if (s.state === 'current') {
      lamp.className = 'admin__lamp admin__lamp--ok';
      title.textContent = 'Aktuell – neuester Stand';
      sub.textContent = `Gerät und Server: ${buildDate(s.local)}`;
      opts.onState?.('current');
    } else {
      lamp.className = 'admin__lamp';
      title.textContent = `Nicht prüfbar: ${s.reason}`;
      sub.textContent = `Dieses Gerät: ${buildDate(s.local)}`;
      opts.onState?.('unknown');
    }
  }

  check.addEventListener('click', () => void run(true));
  fresh.addEventListener('click', () => {
    fresh.disabled = true;
    fresh.textContent = 'Lade …';
    void applyUpdate();
  });
  void run(false);
  return h('div', { class: 'upd' }, h('div', { class: 'admin__lamp-row' }, lamp, h('div', {}, title, sub)), h('div', { class: 'btn-row' }, check, fresh));
}
